import React from 'react';
import { Spinner } from 'core/components/spinner';

import useStyles from './auth-loader.styles';

const AuthLoader = () => {
  const classes = useStyles();
  return (
    <div className={classes.loaderContainer}>
      <div className={classes.loaderCard}>
        <Spinner size={50} />
      </div>
    </div>
  );
};

export default AuthLoader;
